module.exports = __webpack_public_path__ + "img/Chiquita Hudson, Marguerite Harper and Linda Adams, 1966 .c86897a1.jpg";